import http from "@/shared/services/http";

export const listDebtEmployee = (params: any) =>  http.get(`v1/debt-employees`,  { params });
export const allDebtEmployee = (params: any) =>  http.get(`v1/debt-employees/all`,  { params });
export const receiptEmployee = (data: any) =>  http.post(`v1/revenue-expenditures/employee`, data);